export default "__VITE_ASSET__CcMLuc_8__"